import { Button as ButtonComponent } from '@mantine/core'

import styles from './button.module.scss'

export const Button = ButtonComponent.extend({
  classNames: {
    root: styles.root,
  },
})
